import { render } from "./LifetimeGuarantee.vue?vue&type=template&id=263cab4f&scoped=true"
import script from "./LifetimeGuarantee.vue?vue&type=script&lang=js"
export * from "./LifetimeGuarantee.vue?vue&type=script&lang=js"

import "./LifetimeGuarantee.vue?vue&type=style&index=0&id=263cab4f&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263cab4f"]])

export default __exports__